class Dependencies {
    constructor() {
        this.app = null;
    }
    static instance() {
        if (!Dependencies._instance)
            Dependencies._instance = new Dependencies();
        return Dependencies._instance;
    }
}
//template_resolver: Observable<TemplateResolver> = observe(null)
Dependencies._instance = null;
export default Dependencies;
export function deps() {
    return Dependencies.instance();
}
